import { IconButton, IconButtonProps, SvgIconProps } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import CheckIcon from '@mui/icons-material/Check'

interface CopyButtonProps {
  text: string
  onCopy?(text: string, result: boolean): void
  buttonProps?: IconButtonProps
  iconProps?: SvgIconProps
}

const CopyButton = ({ text, onCopy, buttonProps, iconProps }: CopyButtonProps) => {
  const [showCheckIcon, setShowCheckIcon] = useState(false)

  useEffect(() => {
    if (showCheckIcon) {
      setTimeout(() => {
        setShowCheckIcon(false)
      }, 3000)
    }
  }, [showCheckIcon])

  return (
    <CopyToClipboard
      text={text}
      onCopy={(text, result) => {
        setShowCheckIcon(true)
        onCopy?.(text, result)
      }}
    >
      <IconButton {...buttonProps}>
        {showCheckIcon ? <CheckIcon {...iconProps} /> : <ContentCopyIcon {...iconProps} />}
      </IconButton>
    </CopyToClipboard>
  )
}

export default CopyButton
